module.exports = __webpack_public_path__ + "b6d60c056af0cd3e87cd584f00f593dc.png";